import { render, staticRenderFns } from "./VerificationResultBlock.vue?vue&type=template&id=2705105d"
import script from "./VerificationResultBlock.vue?vue&type=script&lang=js"
export * from "./VerificationResultBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports